import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  closeProductModal,
  refreshProductList,
} from "../../../redux/features/productModalSlice";

import { UpdateSize, ViewSize } from "../../../redux/services/UnitSize/unit-size.Services";
import { ActiveCategoryList } from "../../../redux/services/categoriesService/categories.Services";
import { ActiveSubCategoryList } from "../../../redux/services/subCategoriesService/subCategories.Services";
import Swal from "sweetalert2";
import { successToast } from "../../../Utils/toast";

function EditSize({data , refreshData }) {
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const [categories, setCategories] = useState([])
  const [subCategories, setSubCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    id:"",
    size_name: "",
    size_code: "",
    category_id: "",
    sub_category_id: "",
    category_type: "",
    // sort_order: "",
    description: "",
    is_active: 1,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

const handleCategoryChange = async (e) => {
  const categoryId = e.target.value;

  const category = categories.find(
    (item) => item.id === Number(categoryId)
  );

  setFormData((prev) => ({
    ...prev,
    category_id: categoryId,
    sub_category_id: "",
    category_type: category?.slug || "",
  }));

  await loadSubCategories(categoryId);
};
  const loadCategories = async () => {
    try {
      const res = await ActiveCategoryList();

      setCategories(res?.data || []);
    } catch (error) {
      console.log(error);
    }
  };
  const loadSubCategories = async (categoryId) => {
    try {
      const res = await ActiveSubCategoryList(categoryId);

      console.log("Sub Category Response", res);

      setSubCategories(res?.data?.data || []);

    } catch (error) {
      console.log(error);

      setSubCategories([]);
    }
  };
useEffect(() => {
  if (data?.id) {
    getSizeDetails(data.id);
  }

  loadCategories();
}, []);
const getSizeDetails = async (id) => {
  try {
    setLoading(true);

    const res = await ViewSize({ id });

    if (res.data.success) {
      const size = res.data.data;

      setFormData({
        id: size.id,
        size_name: size.size_name || "",
        size_code: size.size_code || "",
        category_id: size.category_id || "",
        sub_category_id: size.sub_category_id || "",
        category_type: size.category_type || "",
        // sort_order: size.sort_order || "",
        description: size.description || "",
        is_active: size.is_active,
      });

      if (size.category_id) {
        await loadSubCategories(size.category_id);
      }
    }
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};
  const handleSubmit = async (e) => {
    e.preventDefault();


    try {
      const payload = {
        id: formData.id,
        size_name: formData.size_name,
        size_code: formData.size_code,
        category_id: Number(formData.category_id),
        description: formData.description,
        is_active: Number(formData.is_active),
      };

      const res = await UpdateSize(payload);
      if (res?.data?.success) {
        successToast(res?.data.message);
        dispatch(refreshProductList());
        dispatch(closeProductModal());
      }
    } catch (error) {
      console.log(error);
      if (error?.response?.status === 422) {
        setErrors(error.response.data.errors || {});
      } else {
        Swal.fire("Error", "Something went wrong", "error");
      }

    }
  };

  return (
    <form onSubmit={handleSubmit} className="row g-3">

      {/* Size Name */}
      <div className="col-md-6">
        <label>
          Size Name <span className="text-danger">*</span>
        </label>

        <input
          type="text"
          name="size_name"
          className={`form-control custumform ${errors?.size_name ? "is-invalid" : ""
            }`}
          placeholder="Enter Size Name"
          value={formData.size_name}
          onChange={handleChange}
        />

        {errors?.size_name && (
          <div className="invalid-feedback d-block">
            {errors.size_name[0]}
          </div>
        )}
      </div>

      {/* Size Code */}
      <div className="col-md-6">
        <label>
          Size Code <span className="text-danger">*</span>
        </label>

        <input
          type="text"
          name="size_code"
          className={`form-control custumform ${errors?.size_code ? "is-invalid" : ""
            }`}
          placeholder="Enter Size Code"
          value={formData.size_code}
          onChange={handleChange}
        />

        {errors?.size_code && (
          <div className="invalid-feedback d-block">
            {errors.size_code[0]}
          </div>
        )}
      </div>

      {/* Category */}
       <div className="col-md-6">
        <label>
          Category <span className="text-danger">*</span>
        </label>
        <select
          name="category_id"
          value={formData.category_id}
          onChange={handleCategoryChange}
          className={`form-control custumform ${errors?.category_id ? "is-invalid" : ""
            }`}
        >
          <option value="">Select Category</option>

          {categories.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>

        {errors?.category_id && (
          <div className="invalid-feedback d-block">
            {errors.category_id[0]}
          </div>
        )}
      </div>

      {/* Sub Category */}
      <div className="col-md-6">
        <label>
          Sub Category <span className="text-danger">*</span>
        </label>
        <select
          name="sub_category_id"
          value={formData.sub_category_id}
          onChange={handleChange}
          className={`form-control custumform ${errors?.sub_category_id ? "is-invalid" : ""
            }`}
        >
          <option value="">Select Sub Category</option>

          {subCategories.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>

        {errors?.sub_category_id && (
          <div className="invalid-feedback d-block">
            {errors.sub_category_id[0]}
          </div>
        )}
      </div>

      {/* Category Type */}
      <div className="col-md-6">
        <label>Category Type</label>

        <input
          type="text"
          name="category_type"
          className="form-control custumform"
          placeholder="Category Type"
          value={formData.category_type}
          onChange={handleChange}
        />
      </div>

      {/* Sort Order */}
      {/* <div className="col-md-6">
        <label>Sort Order</label>

        <input
          type="number"
          name="sort_order"
          className="form-control custumform"
          placeholder="Sort Order"
          value={formData.sort_order}
          onChange={handleChange}
        />
      </div> */}

      {/* Status */}
      <div className="col-md-6">
        <label>Status</label>

        <select
          name="is_active"
          className="form-control custumform"
          value={formData.is_active}
          onChange={handleChange}
        >
          <option value={1}>Active</option>
          <option value={0}>Inactive</option>
        </select>
      </div>

      {/* Description */}
      <div className="col-md-12">
        <label>Description</label>

        <textarea
          rows="4"
          name="description"
          className="form-control custumform"
          placeholder="Enter Description"
          value={formData.description}
          onChange={handleChange}
        />
      </div>

      {/* Submit */}
      <div className="col-12 text-end">
     <button
  type="submit"
  className="add-btn"
  disabled={loading}
>
  {loading ? "Updating..." : "Update Size"}
</button>
      </div>

    </form>
  );
}

export default EditSize;